import React, { useState } from "react"
import { AnimatePresence } from "framer-motion"
import Modal from "./Modal"

const ButtonModal = ({articleTag, myRef, body, buttonClass, title}) => {
  const [modalOpen, setModalOpen] = useState(false)

  const close = () => setModalOpen(false)
  const open = () => setModalOpen(true)

  return (
    <>
      <button
      className={buttonClass}
        onClick={() => (modalOpen ? close() : open())}
        ref={myRef}
      >
        <p>{articleTag}</p>
        <p className="cta-text">{title}</p>
      </button>
      <AnimatePresence
        initial={false}
        exitBeforeEnter={true}
        onExitComplete={() => null}
      >
        {modalOpen && <Modal modalOpen={modalOpen} handleClose={close} body={body} />}
      </AnimatePresence>
    </>
  )
}

export default ButtonModal